import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import HOCLoader from '../HOC/HOCLoader';
import { FormattedMessage } from 'react-intl';

class ServiceFAQ extends Component {
    state = {
        faqList: [],
        loader: true
    };
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.serviceFaqAction(
            {
                providerId: this.props.data.key,
                proServiceId: this.props.data.proServiceId
            },
            this.onDone
        );
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ faqList: data.data, loader: false });
        } else {
            this.setState({ loader: false });
        }
    };
    render() {
        const { faqList } = this.state;
        if (faqList.length === 0) {
            return (
                <p>
                    {' '}
                    <FormattedMessage
                        id="noFaq"
                        defaultMessage="No FAQ Found"
                    />
                </p>
            );
        }
        return (
            <HOCLoader loading={this.state.loader}>
                <div className="tz-2-com tz-2-main">
                    {faqList.map(n => {
                        return (
                            <ExpansionPanel key={n.key}>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography component="h4">
                                        {n.question}
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Typography>{n.answer}</Typography>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        );
                    })}
                </div>
            </HOCLoader>
        );
    }
}

export default connect(null, actions)(ServiceFAQ);



// WEBPACK FOOTER //
// ./src/components/Providers/ServiceFAQ.js